import { isFutureDate } from './is-future-date.mjs';
import { TimeUnit } from './constants/index.mjs';

function isLessThanOneWeekAway(date, now = new Date()) {
  return isFutureDate(date, now) && date.getTime() - now.getTime() < TimeUnit.Week;
}

export { isLessThanOneWeekAway };
